// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_pa-5";
export var filledCircle = "_pa-4";
export var historyEntry = "_pa-3";
export var messageSideLeft = "_pa-1";
export var messageSideRight = "_pa-2";
export var orderTrackingCarouselWrapper = "_pa-6";
export var orderTrackingInfoContainer = "_pa-0";